import { getErrorDetail } from 'components/utility/utils';
import { fetchOrchidAPI } from 'utils/api';

export interface Role {
  id: string;
  name: string;
}

export default async function getRolesForTeam (
  teamId: string,
): Promise<Role[]> {
  const res = await fetchOrchidAPI(`/api/users/v1/team/${teamId}/roles`, {
    method: 'GET',
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return await res.json();
}